<template>
    <div class="p-4 lg:w-1/1 md:w-full">
        <div class="flex items-center gap-2">
            <JetLabel class="w-1/4 my-2" for="id_paket_pengadaan" value="Paket Pengadaan" />
            <Dropdown v-model="form.paket_pengadaan" :loading="loading" :options="pengadaanOption"
                optionLabel="nama_paket_pengadaan" filter filterBy="nama_paket_pengadaan" @filter="fetchPaketPengadaan
                    " placeholder="Select Paket Pengadaan" class="w-3/4" @change="changeMetodeEvaluasi" />
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { Inertia } from "@inertiajs/inertia";
import InputNumber from "primevue/inputnumber";
import Dropdown from "primevue/dropdown";
import RadioButton from "primevue/radiobutton";
import JetLabel from "@/Jetstream/Label";

export default defineComponent({
    components: {
        InputNumber,
        Dropdown,
        RadioButton,
        JetLabel,
    },
    props: {
        form: Object,
    },
    mounted() {
        this.fetchPaketPengadaan({ query: "" });
    },
    data() {
        return {
            pengadaanOption: [],
            loading: false,
        };
    },
    methods: {

        async fetchPaketPengadaan(event) {
            this.loading = true;
            console.log("Keyword : ", event.value);
            try {
                const response = await axios.post(
                    "/dokumen_pengadaan/search_paket_pengadaan",
                    {
                        params: {
                            keyword: event?.value || "",
                        },
                    }
                );
                this.pengadaanOption = response.data;
            } catch (error) {
                console.error("Error fetching paket pengadaan:", error);
            }
            this.loading = false;
        },
    },
    watch: {
        'form.paket_pengadaan': {
            handler(newValue) {
                this.$emit("update:form", newValue);
            }
        }
    }
});
</script>